/* eslint-disable prettier/prettier */
import React from 'react';

// import required modules
import { FreeMode, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import ProductCard from './components/productCard';

import CustomArrow from '@/components/arrow/index';

const env = process.env.NEXT_PUBLIC_APP_ENV;

const list = [
  {
    label: '嘉立创PCB服务',
    describe:
      '1-32层pcb打样，批量生产服务。打样24小时出货免加急费，使用真A级板材，坚持工厂自营的生产模式，保障品质可靠性和稳定性。',
    detailArr: ['FR-4、铝基板', '热电分离铜基板', 'Rogers罗杰斯高频板', 'PTFE铁氟龙高频板'],
    name: 'pcb',
    minNum: 5,
    minPrice: 0,
    delTime: '12h',
    order: 1,
    src: [`https://${env === 'pro' ? 'www' : 'fat'}.jlc.com/newOrder/#/pcb/pcbPlaceOrder`, `https://${env === 'pro' ? 'www' : 'fat'}.jlc.com/portal/vtechnology.html`],
  },
  {
    label: '高多层PCB服务',
    describe:
      '全新高多层专用生产线，线路防焊采用LDI，VCP脉冲电镀等行业先进生产设备，使用名牌板材，精准的阻抗检测仪器，提供高清字符、高品质检验标准，高端包装及运输服务。',
    detailArr: ['6 - 32层板 ', '高精密阻抗板'],
    name: 'multiPcb',
    minNum: 5,
    minPrice: 0,
    delTime: '48h',
    order: 2,
    src: [
      `https://${env === 'pro' ? 'www' : 'fat'}.jlc.com/newOrder/#/pcb/pcbPlaceOrder?stencilLayer=6`,
      `https://${env === 'pro' ? 'www' : 'fat'}.jlc.com/portal/vtechnology.html`,
    ],
  },
  {
    label: '嘉立创PCB量产服务',
    describe:
      '拥有江苏、江西两大自营生产基地，是目前国内较早实现全自动化生产的“PCB智造企业”之一，专注于PCB批量、SMT贴片服务。',
    detailArr: ['好板材', '交期快', '品质高', '免收工程费'],
    name: '量产PCB',
    minNum: 5,
    minPrice: 210,
    delTime: '48h',
    order: 3,
    src: [`https://${env === 'pro' ? 'member' : 'fat'}.zxhgroup.com/#/direct-quote`, `https://${env === 'pro' ? 'www' : 'fat'}.zxhgroup.com/introduce`],
    type: '2',
  },
  {
    label: 'SMT贴片服务',
    describe: '50元起贴，一分钱一个焊点，支持上百万种元器件，全自动生产线，让你的PCB最快可以在半天内完成焊接。',
    detailArr: ['PCBA贴装服务', '插件波峰焊', '双面贴', '元器件专享价'],
    name: 'SMT贴片服务',
    minNum: 5,
    minPrice: 50,
    delTime: '24h',
    order: 4,
    src: [`https://${env === 'pro' ? 'www' : 'fat'}.jlc-smt.com/calc-online`, `https://${env === 'pro' ? 'www' : 'fat'}.jlc-smt.com/vtechnology`],
    type: '3',
  },
  {
    label: 'FPC软板服务',
    describe: '价格优、品质高，支持PI、FR4、钢片、双面胶补强及电磁屏蔽膜，使用高端无胶电解铜箔，耐高温，使用寿命更长。',
    detailArr: ['支持单双面板', '弯折性能好', '打样0元包邮'],
    name: 'FPC软板',
    minNum: 5,
    minPrice: 150,
    delTime: '24h',
    order: 5,
    src: [
      `https://${env === 'pro' ? 'www' : 'fat'}.jlc.com/newOrder/#/pcb/pcbPlaceOrder?stencilLayer=1&pcbLength=&pcbWidth=&pcbNumber=5&layer=%E6%9B%B4%E5%A4%9A&plateType=7`,
      `https://${env === 'pro' ? 'www' : 'fat'}.jlc-fpc.com/technology`,
    ],
  },
  {
    label: '钢网/治具服务',
    describe: '高性价比，37×47激光钢网60元起，德国进口LPKF激光切割，加急最快6小时发货。',
    detailArr: ['激光钢网', '阶梯钢网', '治具'],
    name: '钢网/治具服务',
    minNum: 5,
    minPrice: 60,
    delTime: '6h',
    order: 6,
    src: [`https://${env === 'pro' ? 'www' : 'fat'}.jlc-gw.com/quote-online/steelmesh`, `https://${env === 'pro' ? 'www' : 'fat'}.jlc-gw.com/process-parameters`],
    type: '3',
  },
];
const ProductList = () => {
  return (
    <>
      <div className="custom-group relative m-[116px_auto] h-[475px] w-[1380px]">
        <Swiper
          className="hover:static"
          slidesPerView={4}
          spaceBetween={20}
          freeMode={true}
          pagination={{
            clickable: true,
          }}
          navigation={{
            nextEl: '#custom-next-button',
            prevEl: '#custom-prev-button',
          }}
          modules={[FreeMode, Navigation]}
        >
          {list.map((item, index) => (
            <SwiperSlide key={index}>
              <ProductCard data={item}></ProductCard>
            </SwiperSlide>
          ))}
          {/* 自定义箭头 */}
          <CustomArrow width={40} />
        </Swiper>
      </div>
    </>
  );
};
export default ProductList;
